module.exports = __webpack_public_path__ + "img/home_know_more_img_01_shadow.62bd90ab.png";